// Authentic Nepal imagery — verified local assets only.
// Never use generic stock from other countries.
// If no photo exists for a topic, use illustrationKey (CSS) instead.

import abcTrek from '../images/abc-trek.jpg';
import nepalVillage from '../images/nepal-village.jpg';
import peacePagoda from '../images/peace.jpg';
import janakiMandir from '../images/janaki-mandir.jpg';

export const NEPAL_IMAGES = {
	heroEverest: {
		src: '/images/hero-nepal.jpg',
		alt: 'Trekkers at a Buddhist stupa with prayer flags, Ama Dablam and Everest region peaks, Nepal',
		subject: 'Everest region trekking',
		verified: true,
	},
	annapurnaAbc: {
		src: abcTrek,
		alt: 'Welcome sign at Annapurna Base Camp, 4,130 metres, Nepal Himalaya',
		subject: 'Annapurna Base Camp trek',
		verified: true,
	},
	himalayanVillage: {
		src: nepalVillage,
		alt: 'Traditional stone village with prayer flags beneath snow peaks, Nepal Himalaya',
		subject: 'High-altitude Nepali village',
		verified: true,
	},
	peacePagoda: {
		src: peacePagoda,
		alt: 'World Peace Pagoda at sunrise, Pokhara, Nepal',
		subject: 'Buddhist stupa, Pokhara',
		verified: true,
	},
	janakiMandir: {
		src: janakiMandir,
		alt: 'Janaki Mandir temple facade with courtyard reflection, Janakpur, Nepal',
		subject: 'Janaki Mandir, Janakpur',
		verified: true,
		credit: 'CC BY-SA 4.0 — Wikimedia Commons',
	},
};

export function nepalPhoto(key) {
	return NEPAL_IMAGES[key] || null;
}

export function nepalImageSrc(key, fallback = '/images/hero-nepal.jpg') {
	const img = NEPAL_IMAGES[key];
	return img ? img.src : fallback;
}

export function nepalImageAlt(key) {
	const img = NEPAL_IMAGES[key];
	return img ? img.alt : 'Nepal';
}

// Fallback photos for destinations without API hero images
const DESTINATION_IMAGE_KEYS = {
	'everest-base-camp': 'heroEverest',
	'annapurna-base-camp': 'annapurnaAbc',
	'phewa-lake': 'peacePagoda',
	'boudhanath-stupa': 'peacePagoda',
	'bhaktapur-durbar-square': 'peacePagoda',
	'kathmandu-durbar-square': 'peacePagoda',
	'chitwan-national-park': 'himalayanVillage',
	'sagarmatha-national-park': 'heroEverest',
};

export function destinationFallbackSrc(slug) {
	const key = DESTINATION_IMAGE_KEYS[slug];
	return key ? nepalImageSrc(key) : nepalImageSrc('heroEverest');
}
